import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from '@emotion/styled';

import { CircularProgress,  TextField, Button, Typography} from '@mui/material';

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useErrorManager from "../../hooks/useErrorManager";

import { useBreadcrumb } from '../../contexts/BreadcrumbContext'; // Import breadcrumb context

const StyledError = styled(Typography)`
  text-align: center;
  margin-top: 10px;
`;

function EditLocation() {
    const { locationId } = useParams();

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    const [loading, setLoading] = useState(true);

    const { setError, clearError, getError } = useErrorManager();
    const { updateBreadcrumb } = useBreadcrumb(); // Use breadcrumb context to update breadcrumb
    
    const navigate = useNavigate();
    const axiosInstance = useAxiosPrivate();  

    useEffect(() => {
        const fetchLocationDetails = async () => {
            try {
                const response = await axiosInstance.get(`/locations/${locationId}/details`);
                setName(response.data[0].name);
                setDescription(response.data[0].description);
                clearError('fetch');
                setLoading(false);

                updateBreadcrumb([
                    { label: 'Manage Locations', link: '/locations' },
                    { label: response.data[0].name || 'Location', link: `/locations/${locationId}` }, // Dynamically set location name
                    { label: 'Edit', link: null }
                ]);

            } catch (error) {
                setError('fetch', error.message);
                setLoading(false);
            }
        };

        fetchLocationDetails();
    }, [locationId]);



    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                name,
                description,
            };
            await axiosInstance.put(`/locations/${locationId}/edit`, payload);
            setName('');
            setDescription('');
            clearError('create');
            navigate(`/locations`, { state: { success: 'Location updated successfully' }} )
        } catch (error) {
            setError('edit', error.message);
        }
    };


    return (
        loading ? (
                <CircularProgress />
            ) : (
                <>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            label={<span>Name</span>}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            fullWidth
                            required
                            margin="normal"
                        />
                        <TextField
                            label={<span>Description</span>}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            fullWidth
                            required
                            margin="normal"
                        />
                        <Button type="submit" variant="contained" color="primary" fullWidth>
                            Save
                        </Button>
                        {getError('edit') && <StyledError variant="body2">{getError('edit')}</StyledError>}
                    </form>
                </>        
            )
    );
}

export default EditLocation;
